import geometry from '../../scene/util/geometry';
import constants from '../../settings/constants';
import { getUserAgent } from '../userAgent';

function getDefaultPac() {
  const defaultPAC = {
    model: {
      items: [],
    },

    version: '1.1',
  };

  function getPoints() {
    const userAgent = getUserAgent();
    if (
      userAgent.deviceType === 'mobile' &&
      userAgent.orientation === 'portrait'
    ) {
      return constants.WALL.pointsMobilePortrait;
    } else if (
      userAgent.deviceType === 'mobile' &&
      userAgent.orientation === 'landscape'
    ) {
      return constants.WALL.pointsMobileLandscape;
    } else if (userAgent.deviceType === 'tablet') {
      return constants.WALL.pointsTablet;
    } else {
      return constants.WALL.points;
    }
  }

  if (constants.WALL) {
    const { height, width } = geometry.surround(getPoints());
    defaultPAC.wall = {
      points: getPoints(),
      size: {
        height,
        width,
      },
    };
  }

  return defaultPAC;
}

export default getDefaultPac;
